import { FormValidatorSettings } from 'ngl-form-validator';

export const FORM_VALIDATOR_SETTINGS: FormValidatorSettings = {
  defaultErrorMessage: 'Invalid field',
  errorMessages: [
    { error: 'required', message: 'Required field' },
  ]
}
